module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_pet-3cd3b47d9135f4147b472653da6737ae.webp";